<app-question-template [form]="form" [question]="question" *ngIf="dateTimeSettings$ | async; let settings">
	<ion-datetime
		(ionChange)="onChange($event)"
		[firstDayOfWeek]="settings.firstDayOfWeek"
		[hourCycle]="hourCycle$ | async"
		[presentation]="presentation"
		[value]="answer?.answers[0]"
		[size]="isV2() ? 'fixed' : 'cover'"
		[class.date-time-question-v2-calendar]="isV2()"
	></ion-datetime>
</app-question-template>
